import { render, staticRenderFns } from "./MobileAbout.vue?vue&type=template&id=6aab64e8&scoped=true&"
import script from "./MobileAbout.vue?vue&type=script&lang=js&"
export * from "./MobileAbout.vue?vue&type=script&lang=js&"
import style0 from "./MobileAbout.vue?vue&type=style&index=0&id=6aab64e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aab64e8",
  null
  
)

export default component.exports